<template>
    <div
        class="user-portfolio-tag-item"
        :class="{
            'user-portfolio-tag-item--selected': selected,
            'user-portfolio-tag-item--outline': outline,
        }"
        :style="{
            '--fill_color': `#${catalogItem.meta.fill_color}`,
            '--text_color': `#${catalogItem.meta.text_color}`,
        }"
        @click="click"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
            <circle cx="3" cy="3" r="3" />
        </svg>
        <span>{{ catalogItem.field_value }}</span>
    </div>
</template>

<script>
export default {
    name: 'PortfolioTag',
    emits: ['click'],
    props: {
        catalogItem: Object,
        selected: {
            type: Boolean,
            default: () => false,
        },
        outline: {
            type: Boolean,
            default: () => false,
        },
    },
    methods: {
        click() {
            this.$emit('click', this.catalogItem);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";
@import '~@/styles/variables';

.user-portfolio-tag-item {
    --fill_color: #{$color-black-text};
    --text_color: #{$color-black-text};

    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: mrem(4) mrem(16) mrem(4) mrem(8);
    gap: mrem(8);
    border-radius: mrem(25) mrem(60) mrem(60) mrem(25);
    border: mrem(1) solid var(--text_color);
    color: $color-black-text;

    font-size: mrem(12);
    font-weight: 600;
    line-height: mrem(20);

    @include on-desktop {
        padding: rem(4) rem(16) rem(4) rem(8);
        gap: rem(8);
        border-radius: rem(25) rem(60) rem(60) rem(25);
        border-width: rem(1);
        font-size: rem(12);
        line-height: rem(20);
    }

    svg {
        width: mrem(6);
        height: mrem(6);

        @include on-desktop {
            width: rem(6);
            height: rem(6);
        }

        circle {
            fill: var(--text_color);
        }
    }

    &--selected {
        color: var(--text_color);
        background: var(--fill_color);
        border: mrem(1) solid var(--fill_color);

        @include on-desktop {
            border-width: rem(1);
        }
    }

    &--outline {
        border: none;
        color: var(--text_color);
    }
}
</style>
